import { render, staticRenderFns } from "./AgentVerification.vue?vue&type=template&id=780c9ae7&"
import script from "./AgentVerification.vue?vue&type=script&lang=js&"
export * from "./AgentVerification.vue?vue&type=script&lang=js&"
import style0 from "./AgentVerification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports